import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Optional, Inject, NgModule } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ResizeObserver } from '@juggle/resize-observer';

const RESIZE_OBSERVER = new InjectionToken("Resize Observer", {
    providedIn: "root",
    factory: () => window.ResizeObserver || null
});

class NgResizeObserver extends Observable {
}
class ResizeObserverService {
    constructor(chgRef, el, ResizeObserver) {
        this.chgRef = chgRef;
        this.el = el;
        this.ResizeObserver = ResizeObserver;
        this.onResizeSubject = new Subject();
        this.onResize = this.onResizeSubject.asObservable();
        if (this.el === null) {
            console.error(`ng-resize-observer: No provider for ElementRef. This error is most likely because you added the ng-resize-observer provider in a @NgModule. Only add ng-resize-observer on @Component()`);
            return;
        }
        if (this.ResizeObserver === null) {
            console.error(`ng-resize-observer: ResizeObserver not available. Use the ponyfill module: NgResizeObserverPonyfillModule.`);
            return;
        }
        this.observe();
    }
    ngOnDestroy() {
        this.unobserve();
        this.onResizeSubject.complete();
    }
    observe() {
        this.resizeObserver = new this.ResizeObserver((entries) => {
            const entry = entries && entries[0];
            if (entry) {
                this.onResizeSubject.next(entry);
                this.chgRef.detectChanges();
            }
        });
        this.resizeObserver.observe(this.target);
    }
    unobserve() {
        this.resizeObserver.unobserve(this.target);
    }
    get target() {
        return this.el.nativeElement;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.2", ngImport: i0, type: ResizeObserverService, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef, optional: true }, { token: RESIZE_OBSERVER }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.1.2", ngImport: i0, type: ResizeObserverService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.2", ngImport: i0, type: ResizeObserverService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef, decorators: [{
                    type: Optional
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [RESIZE_OBSERVER]
                }] }]; } });
function ngResizeObserverFactory(resizeObserverService) {
    return resizeObserverService.onResize;
}
const NgResizeObserverProvider = {
    provide: NgResizeObserver,
    useFactory: ngResizeObserverFactory,
    deps: [ResizeObserverService],
};

function ponyFillFactory() {
    return window.ResizeObserver || ResizeObserver;
}
;
const polyfillProvider = { provide: RESIZE_OBSERVER, useFactory: ponyFillFactory };
class NgResizeObserverPonyfillModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.2", ngImport: i0, type: NgResizeObserverPonyfillModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.2", ngImport: i0, type: NgResizeObserverPonyfillModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.2", ngImport: i0, type: NgResizeObserverPonyfillModule, providers: [polyfillProvider] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.2", ngImport: i0, type: NgResizeObserverPonyfillModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [polyfillProvider]
                }]
        }] });

const ngResizeObserverProviders = [
    NgResizeObserverProvider,
    ResizeObserverService,
];
const ngResizeObserverProvidersWithPonyfill = [
    ...ngResizeObserverProviders,
    polyfillProvider,
];

/**
 * Generated bundle index. Do not edit.
 */

export { NgResizeObserver, NgResizeObserverPonyfillModule, ngResizeObserverProviders, ngResizeObserverProvidersWithPonyfill };
